module.exports = __webpack_public_path__ + "static/media/rajuraman.25d91d9e.jpg";